import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Plus } from '@phosphor-icons/react';

export const AgencyMatchDialog = ({
  matchDialog, setMatchDialog, matchEntryIdx, entries, matchOptions,
  handleSelectAgency, openNewAgencyDialog, formatCurrency,
}) => (
  <Dialog open={matchDialog} onOpenChange={setMatchDialog}>
    <DialogContent className="max-w-md">
      <DialogHeader><DialogTitle>Agency Select Karo</DialogTitle></DialogHeader>
      {matchEntryIdx !== null && entries[matchEntryIdx] && (
        <div className="space-y-3">
          <p className="text-sm text-gray-600">Input: <strong>{entries[matchEntryIdx].original_text || entries[matchEntryIdx].agency_name}</strong></p>
          <div className="space-y-2 max-h-64 overflow-y-auto">
            {matchOptions.map((m, i) => (
              <button key={m.id || `match-${i}`} onClick={() => handleSelectAgency(matchEntryIdx, m)}
                className="w-full text-left p-3 border border-gray-200 rounded-lg hover:border-[#002FA7] hover:bg-blue-50 transition-all"
                data-testid={`match-option-${i}`}
              >
                <div className="flex justify-between items-center">
                  <span className="font-medium">{m.name}</span>
                  <span className="text-xs bg-blue-100 text-blue-700 px-2 py-0.5 rounded">{m.score}%</span>
                </div>
                <span className="text-sm text-gray-500">Rate: {formatCurrency(m.rate)}</span>
              </button>
            ))}
          </div>
          <Button variant="outline" onClick={() => openNewAgencyDialog(matchEntryIdx)} className="w-full text-purple-600" data-testid="match-add-new-btn">
            <Plus size={16} className="mr-2" /> Nahi mila? New Agency Add Karo
          </Button>
        </div>
      )}
    </DialogContent>
  </Dialog>
);
